import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { injectRuntimeConfig } from '../core/config/runtime-config.token';
import { buildBackendUrl } from '../core/config/runtime-config.provider';
import { SessionFacade } from '../core/state/session.store';

export const authHeadersInterceptor: HttpInterceptorFn = (request, next) => {
  const runtimeConfig = injectRuntimeConfig();
  const sessionFacade = inject(SessionFacade);
  const authHeaders = sessionFacade.authHeaders();
  const loginUrl = buildBackendUrl(runtimeConfig, 'login');
  const backendBaseUrl = buildBackendUrl(runtimeConfig, '');
  const shouldAttachHeaders =
    request.url !== loginUrl &&
    (request.url.startsWith(backendBaseUrl) ||
      request.url.startsWith(runtimeConfig.backend.reverseGeocodeUrl) ||
      request.url.startsWith(runtimeConfig.backend.forwardGeocodeUrl));

  if (!authHeaders || !shouldAttachHeaders) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: authHeaders
    })
  );
};
